import React from 'react';
import { motion } from 'framer-motion';
import { FaConciergeBell, FaSpa, FaUtensils, FaSwimmingPool, FaDumbbell, FaCar, FaBriefcase, FaBaby } from 'react-icons/fa';
import Newsletter from '../components/Newsletter/Newsletter';
import './Services.css';

const iconMap = { FaConciergeBell, FaSpa, FaUtensils, FaSwimmingPool, FaDumbbell, FaCar, FaBriefcase, FaBaby };

const services = [
  { icon: 'FaConciergeBell', title: '24/7 Concierge', description: 'Our dedicated concierge team is available around the clock to assist with reservations, tours, and any special requests your heart desires.' },
  { icon: 'FaSpa', title: 'Luxury Spa', description: 'Rejuvenate your body and mind with a comprehensive range of spa treatments, massages, and wellness therapies at our award-winning Serenity Spa.' },
  { icon: 'FaUtensils', title: 'Fine Dining', description: 'Experience culinary excellence at our award-winning restaurant, featuring seasonal menus crafted by world-class chefs using locally sourced ingredients.' },
  { icon: 'FaSwimmingPool', title: 'Infinity Pool', description: 'Our rooftop infinity pool offers stunning panoramic views and a serene escape from the city below, open 6 AM to 10 PM daily.' },
  { icon: 'FaDumbbell', title: 'Fitness Center', description: 'Maintain your wellness routine in our fully equipped 24-hour gym. Personal training sessions and group classes available upon request.' },
  { icon: 'FaCar', title: 'Airport Transfer', description: 'Start and end your journey in comfort with our luxury fleet and professional drivers available 24 hours, 7 days a week.' },
  { icon: 'FaBriefcase', title: 'Business Center', description: 'State-of-the-art business center with private meeting rooms, high-speed internet, AV equipment, and full secretarial support.' },
  { icon: 'FaBaby', title: "Kids Club", description: "A safe, fun-filled environment for our youngest guests with supervised activities, arts and crafts, and age-appropriate entertainment." },
];

export default function Services() {
  return (
    <main>
      <div className="page-banner">
        <div className="page-banner-content">
          <span className="section-badge">World-Class</span>
          <h1>Services & Amenities</h1>
          <p>Every luxury, every convenience</p>
        </div>
      </div>

      <section className="section services-page">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Our Offerings</span>
            <h2 className="section-title">Everything You Need</h2>
            <div className="gold-line" />
            <p className="section-subtitle">
              From the moment you arrive until your reluctant departure, every comfort and luxury is at your fingertips.
            </p>
          </div>

          <div className="services-grid">
            {services.map((service, i) => {
              const Icon = iconMap[service.icon];
              return (
                <motion.div
                  key={service.title}
                  className="service-card"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                >
                  <div className="service-icon">{Icon && <Icon />}</div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section services-cta-section">
        <div className="container" style={{ textAlign: 'center' }}>
          <span className="section-badge">Ready to Experience?</span>
          <h2 className="section-title">Book Your Luxury Escape</h2>
          <div className="gold-line" />
          <p className="section-subtitle" style={{ marginBottom: '36px' }}>
            Reserve your stay today and immerse yourself in the world of Grand Luxe.
          </p>
          <a href="/booking" className="btn btn-primary">Reserve Now</a>
        </div>
      </section>

      <Newsletter />
    </main>
  );
}
